import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useUserContext } from 'providers/UserProvider';
import auth from 'api/core/auth';
import HomeRedirector from './HomeRedirector';

const AuthGuardRoute = ({ element }) => {
  const location = useLocation();
  const { isLoading, isSuperuser, selectedWarehouse } = useUserContext();

  if (!auth.isAuthenticated()) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (isLoading) {
    // Return a loading indicator or temporary component instead of null
    // This prevents the router from triggering the catch-all route
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: '100vh' }}
      >
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (!isSuperuser && !selectedWarehouse) {
    return <HomeRedirector />;
  }

  return element;
};

export default AuthGuardRoute;
